export default __webpack_public_path__ + "static/media/Wetland Gauntlets.0837f885.jpg";